export enum Dlq {
    InboundEmail = 'InboundEmail',
    SendEmail = 'SendEmail',
    InboundEmailAI = 'InboundEmailAI',
    HeraldProcessing = 'HeraldProcessing',
}
